export const defaultColors: string[] = [
  '#ff8000',
  '#ffff00',
  '#00ff00',
  '#00ffff',
  '#0000ff',
  '#ff0000',
];
